<template>
<!--:permanent="$vuetify.breakpoint.mdAndUp"-->
  <v-navigation-drawer clipped app  v-model="drawer">
     <v-list-item v-if="!$vuetify.breakpoint.mdAndUp" @click="$router.push('/');showDrawer(false)">
        <v-list-item-content >
          <v-list-item-title class="title text-uppercase animated lightSpeedIn" >
            
      <span class="amberd--text">live</span>
      <span class="font-weight-light">beam</span>  
          </v-list-item-title>
          <v-list-item-subtitle>
            Event Admin
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>
    <v-list dense nav>
      <v-list-item v-for="item in items" :key="item.title" link :to="'/event/' + $route.params.eventid + item.link" :exact="item.exact">
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ item.title }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
import { mapState, mapActions } from "vuex";

export default {
  name: 'default-drawer', 
 data: () => ({ 
      eventId: null,
      timeout: 0,
      items: [
          { title: 'Event', icon: 'mdi-view-dashboard', link: '', exact: true },
          { title: 'Presentations', icon: 'mdi-presentation', 
          link: '/screens', exact: false}
        ],
        right: null
  }),
   methods: {
        ...mapActions("application", ["toggleLoading", "setError", "showDrawer"])
   },
  computed: {   
    drawer: {
      get() {
        return this.$store.state.application.drawer;
      },
      set(val) {
        this.showDrawer(val);
      }
    }
  }
};
</script>
